(() => {
  const itemSelector = '[data-ks-mega-item]';
  const triggerSelector = '[data-ks-mega-trigger]';
  let closeTimer;

  const getItem = (element) => element && element.closest(itemSelector);

  const closeMenu = (item, returnFocus = false) => {
    if (!item) return;
    const trigger = item.querySelector(triggerSelector);
    item.classList.remove('is-open');
    trigger?.setAttribute('aria-expanded', 'false');
    if (returnFocus) trigger?.focus();
  };

  const openMenu = (item, focusFirstLink = false) => {
    if (!item) return;
    document.querySelectorAll(`${itemSelector}.is-open`).forEach((openItem) => {
      if (openItem !== item) closeMenu(openItem);
    });
    item.classList.add('is-open');
    item.querySelector(triggerSelector)?.setAttribute('aria-expanded', 'true');
    if (focusFirstLink) item.querySelector('[data-ks-mega-panel] a')?.focus();
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(triggerSelector);
    if (trigger) {
      const item = getItem(trigger);
      const willOpen = !item.classList.contains('is-open');
      closeMenu(item);
      if (willOpen) openMenu(item);
    } else if (!event.target.closest(itemSelector)) {
      document.querySelectorAll(`${itemSelector}.is-open`).forEach((item) => closeMenu(item));
    }
  });

  document.addEventListener('pointerover', (event) => {
    if (!window.matchMedia('(hover: hover) and (min-width: 1200px)').matches) return;
    const item = getItem(event.target);
    if (!item || item.contains(event.relatedTarget)) return;
    window.clearTimeout(closeTimer);
    openMenu(item);
  });

  document.addEventListener('pointerout', (event) => {
    if (!window.matchMedia('(hover: hover) and (min-width: 1200px)').matches) return;
    const item = getItem(event.target);
    if (!item || item.contains(event.relatedTarget)) return;
    window.clearTimeout(closeTimer);
    closeTimer = window.setTimeout(() => closeMenu(item), 180);
  });

  document.addEventListener('keydown', (event) => {
    const item = getItem(event.target);
    if (event.key === 'Escape') {
      const openItem = item || document.querySelector(`${itemSelector}.is-open`);
      if (openItem?.classList.contains('is-open')) {
        event.preventDefault();
        closeMenu(openItem, true);
      }
      return;
    }
    const trigger = event.target.closest(triggerSelector);
    if (trigger && event.key === 'ArrowDown') {
      event.preventDefault();
      openMenu(getItem(trigger), true);
    }
  });

  document.addEventListener('focusout', (event) => {
    const item = getItem(event.target);
    if (!item) return;
    window.setTimeout(() => {
      if (!item.contains(document.activeElement)) closeMenu(item);
    }, 0);
  });
})();
